export const MAX_INPUT_NUM = 99999
